import styled, { css } from 'styled-components';
import { FInter, FlexBox, Colors } from '@brg/ui';
import { LayoutConst } from "../../../core";

export const SlideNavigationWrapper = styled(FlexBox)`
    flex-direction: column;
    width: 100%;
`;

export const DropdownItemsWrapper = styled.div<{isCompetition?: boolean, isWhite?: boolean, rightPos?: boolean, leftPos?: boolean}>`
    z-index: 100000;
    .dropdown-element-popup {
        z-index: 99999;
        background-color: ${Colors.geoWhite21};
        
  .dropdown-show {
    z-index: 99999;
  }
        .dropdown-list-item {
            width: 224px;
            background-color: ${p => p.theme.mainDropdownStyles.bg};
            color: ${p => p.theme.mainDropdownStyles.color};

            &:hover {
                background-color: ${p => p.theme.mainDropdownStyles.hoverBG};
            }
        }
    }
  
  ${({isCompetition}) => isCompetition && css`
    .dropdown-element-popup {
      background: #464645 !important;
      .dropdown-list-item {
        background: #464645 !important;
        color: #fefefe !important;

        &:hover {
          background: #2c2c2b !important;
        }
      }
    }
  `}

  ${({isWhite}) => isWhite && css`
    .dropdown-element-popup {
      background: transparent !important;
      .dropdown-list-item {
          font-size: 17px;
          line-height: 22px;
          letter-spacing: -0.02em;
          font-weight: 600 !important;
          color: ${p => p.theme.mainDropdownStyles.color} !important;

          background: ${p => p.theme.mainDropdownStyles.bg} !important;

          &:hover {
               background: rgb(231, 231, 231) !important;
          }
          
          @media(max-width: ${LayoutConst.screen.l_16}px) {
              font-size: 15px;
              line-height: 20px;
          }

          @media (max-width: ${LayoutConst.screen.md}px) {
              font-size: 13px;
                line-height: 15px;
                display: block;
                width: 403px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
          }
          @media (max-width: ${LayoutConst.screen.s - 1}px) {
              width: 170px;
          }
          
         
      }
        
    }
  `}
  .dropdown-element-popup {
    min-width: 224px !important;
    width: 224px;
    overflow: hidden;
         ${({rightPos, leftPos}) =>  leftPos ? css`
         @media (max-width: ${LayoutConst.screen.s - 1}px) {
           left: 50%;
           transform: translateX(-15%);
           min-width: 170px;
           max-width: 170px;
           overflow: hidden;

       }
        ` : rightPos ? css`
            @media (max-width: ${LayoutConst.screen.s - 1}px) {
            right: 0;
            min-width: 170px;
            max-width: 170px;
            overflow: hidden;

        }
         ` : css`
          @media (max-width: ${LayoutConst.screen.s - 1}px) {
            left: 50%;
            transform: translateX(-50%);
            min-width: 170px;
            max-width: 170px;
            overflow: hidden;

        }
         `
         }
    }
    .dropdown-button{
        ${({rightPos}) =>  rightPos && css`
            // margin-left: -10px;
        `}
    }
`;

export const SlideNavigationWrapperItem = styled(FInter.SmallTextBoldFlex)<{
    active: boolean;
    white_theme: boolean;
    padding?: number;
    whiteSpace?: boolean;
    disableTab?: boolean;
    isTitle?: boolean;
    isDesigner?: boolean;
    isHseDeziiign?: boolean;
    smallTab?: boolean;
    isCGRAVE?: boolean;
    offsetVisible?: boolean;
    floatingTabs?: boolean;
    blueSelect?: boolean;
    color?: string;
    hover?: string;
    isTeamOrCoursePage?: boolean
    isGreyColorText?: boolean,
    noLeftPadding?: boolean,
    customGap?: string | number
    isExport?: boolean
    $competitionMobileUnderline?: boolean
    $showActiveTabUnderline?: boolean
    $forceMobile?: boolean
    activeUnderlineColor?: string
}>`
    color: ${(p) => {
      if(!p.active && p.isGreyColorText) {
        return p.theme.designerPage.slideHover
      }
      return (p.active ? (p?.color || p.theme.designerPage.fill) : p.theme.designerPage.slideLineInActive)
    }};
    cursor: pointer;
    transition: all 0.2s;
    //padding-bottom: 10px;
    // border-bottom: 2px solid ${({active, theme}) => (active ? theme.designerPage.slideLine : 'transparent')};
    @media (min-width: ${LayoutConst.screen.s}px) {
        ${(p) =>
          p.$showActiveTabUnderline == null &&
          !p.blueSelect &&
          !p.isTitle &&
          !(p.isDesigner && !p.smallTab && !p.isExport) &&
          css`
            border-bottom: 2px solid
              ${p.active
                ? p.activeUnderlineColor ??
                  p.theme.designerPage.slideNavActiveTabUnderline ??
                  p.theme.designerPage.slideLine
                : 'transparent'};
          `}
    }
    font-weight: 600;
    font-size: ${({isDesigner}) => isDesigner ? 15 : 17}px;
    white-space: nowrap;
    line-height: ${({isDesigner}) => isDesigner ? 20 : 22}px;
    position: relative;
    letter-spacing: -0.02em;
    align-items: center;
    z-index: 2;
    text-transform: ${({isDesigner}) => isDesigner ? 'lowercase' : ''};
    display: block;
        max-width: ${({isTitle}) => isTitle ? 'none' : '460px'};
        overflow: ${({isTitle}) => isTitle ? 'visible' : 'hidden'};
        white-space: ${({isTitle}) => isTitle ? 'normal' : 'nowrap'};
        text-overflow: ${({isTitle}) => isTitle ? 'unset' : 'ellipsis'};

    .corner-svg {
        width: 10px;
        height: 10px;
        margin-left: 5px;
        position: absolute;
        right: -15px;
        top: 50%;
        transform: translateY(-50%);
        transition: fill 0.2s;
    }

    ${({ blueSelect , active, theme }) => blueSelect && css`
        background-color: ${ active ? theme.designerPage.blueSelectBG : 'transparent' };
        color: ${ active ? theme.designerPage.blueSelectColor : theme.designerPage.slideLineInActive };
        padding: ${ active ? '6px 16px' : '6px 0px' };
        border-radius: 3px;
        // height: 34px;
    `}; 
    
    ${p => p.isTitle ? css`
        font-weight: 600;
        font-size: 60px;
        line-height: 70px;
    `: null}

    ${p => p.disableTab ? css`
        color: ${Colors.galBlack31};
        pointer-events: none;
    `: null}
    
    &:not(:last-child) {
        margin-right: ${({customGap, $forceMobile}) => customGap || customGap === 0? customGap : $forceMobile ? 0 : 24}px;
    }

    ${p => p.isDesigner && !p?.smallTab && !p?.isExport ? css`
      padding: 8px 16px;

      @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 6px 16px;
      }

      border-radius: 3px;
      user-select: none;
      
      ${p.active ? css`
      background: ${p.isCGRAVE ? '#2C2C2B' : p.theme.designerPage.slideItemBg};
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
      color: ${p.isCGRAVE ? '#FEFEFE' : ''};


      &:first-child {
        padding-left: 16px;
      }
    `: null}

    
    `: null}
    
    ${({ active, hover }) => css`
        &:hover {
            color: ${p => active ? hover : p.theme.designerPage.slideHover };
            transition: color 0.2s;

            .corner-svg {
                path {
                    fill: ${p => p.theme.designerPage.slideHover };
                    transition: fill 0.2s;
                }
            }
        }
        `
    };

    ${p => p.smallTab ? css`
        border-radius: 3px;
        user-select: none;
        background: transparent !important;
        box-shadow: none !important;
        ${p.isDesigner && 'padding: 8px 16px;'}
    ` : null};

    
    ${p => !p.isTitle ? css`
     @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
    ` : null};


    @media (max-width: ${LayoutConst.screen.m}px) {
        padding-bottom: ${({ blueSelect, isHseDeziiign, isTeamOrCoursePage, isDesigner }) => (blueSelect || isDesigner) ? '6px' : 0};
        margin-bottom: ${({ blueSelect, isHseDeziiign, isTeamOrCoursePage, isDesigner }) => '0px'};
        font-weight: 600;
        
        ${({ floatingTabs, isDesigner }) => floatingTabs ? css`
            transition: none;
        ` : isDesigner ? css`
            font-size: 15px;
            line-height: 20px;
            padding: 6px 16px;
        ` : null};

        &:not(:last-child) {
            margin-right: ${p => p?.padding ? `${p?.padding}px` : '16px'};
        }
    }
    @media (max-width: ${LayoutConst.screen.m}px) {
        display: block;
        max-width: ${({isTitle}) => isTitle ? 'none' : '270px'};
        overflow: ${({isTitle}) => isTitle ? 'visible' : 'hidden'};
        white-space: ${({isTitle}) => isTitle ? 'normal' : 'nowrap'};
        text-overflow: ${({isTitle}) => isTitle ? 'unset' : 'ellipsis'};
    }

    @media(max-width: 320px) {
        white-space: ${p => p?.whiteSpace ? 'pre-wrap' : 'nowrap'};
    }

    @media(max-width: 320px) {
        white-space: ${p => p?.whiteSpace ? 'pre-wrap' : 'nowrap'};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        background: none;
        border-top: none;
        border-left: none;
        border-right: none;
        box-shadow: none;
    }

    ${p => p.isTitle ? css`
        @media (max-width: ${LayoutConst.screen.l_12}px) {
            font-size: 65px;
            line-height: 75px;
            letter-spacing: -0.005em;
        }

        @media (max-width: ${LayoutConst.screen.m_1024}px) {
            font-size: 43px;
            line-height: 51px;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px;
            line-height: 34px;
            letter-spacing: -0.56px;
        }
        
        @media (max-width: ${LayoutConst.screen.sm}px) {
            font-size: 28px;
            line-height: 34px;
        }
    `: null}

    @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 6px 16px;
        margin-right: 0 !important;

        ${p => p.noLeftPadding && !p.$forceMobile && `padding-left: 0;`}

        :hover {
            color: ${(p) => (p.active ? (p?.color || p.theme.designerPage.fill) : p.theme.designerPage.slideLineInActive)};
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding-left: 16px;
        border-radius: 0;
        ${(p) =>
          p.$showActiveTabUnderline === false
            ? css`
                border-bottom: 2px solid transparent;
              `
            : p.$competitionMobileUnderline
            ? css`
                border-bottom: ${p.active ? '2px solid #FFFFFF' : '2px solid transparent'};
                margin-bottom: -1px;
              `
            : css`
                border-bottom: ${p.active
                  ? `2px solid ${
                      p.activeUnderlineColor ??
                      p.theme.designerPage.slideNavActiveTabUnderline ??
                      p.theme.designerPage.slideLine
                    }`
                  : '2px solid transparent'};
              `}
    }

    ${(p) =>
      p.$forceMobile &&
      css`
        padding: 6px 16px;
        border-radius: 0;
        ${p.$showActiveTabUnderline === false
          ? css`
              border-bottom: 2px solid transparent;
            `
          : p.$competitionMobileUnderline
          ? css`
              border-bottom: ${p.active
                ? '2px solid #FFFFFF'
                : '2px solid transparent'};
              margin-bottom: -1px;
            `
          : css`
              border-bottom: ${p.active
                ? `2px solid ${
                    p.activeUnderlineColor ??
                    p.theme.designerPage.slideNavActiveTabUnderline ??
                    p.theme.designerPage.slideLine
                  }`
                : '2px solid transparent'};
            `}
      `}

    ${(p) =>
      p.$competitionMobileUnderline &&
      css`
        max-width: none;
        overflow: visible;
        text-overflow: unset;

        @media (max-width: ${LayoutConst.screen.m}px) {
          max-width: none;
          overflow: visible;
          text-overflow: unset;
        }
      `}
`;

export const SlideNavigationWrapperLine = styled.div`
    background: ${(p) => p.theme.designerPage.slideLine};
    opacity: 0.21;
    border: 1px solid ${(p) => p.theme.designerPage.slideLine};
    box-sizing: border-box;
    width: 100%;
    height: 1px;
`;

export const SlideNavigationItemsShadow = styled(FlexBox)`
    background: ${(p) => p.theme.designerPage.slideShadow};
    height: 100%;
    width: 64px;
    position: absolute;
    right: 0;
`

export const SlideNavigationItemsWrapper = styled(FlexBox)<{ overflowX?: boolean, isPaymentSuccess?: boolean, isDesigner?: boolean, isPayment?: boolean, stretch?: boolean, fullWidth?: boolean, smallTab?: boolean, gradientVisible?: boolean, isHseDeziiign?: boolean, $competitionMobileBaseline?: boolean }>`
    position: relative;

    ${(p) =>
      p.$competitionMobileBaseline &&
      css`
        @media (max-width: ${LayoutConst.screen.s - 1}px) {
          margin-left: -10px;
          /* border-bottom: 1px solid #5d5d5d; */
        }
      `}
    //margin-bottom: 16px;
    // align-items: {({isHseDeziiign}) => isHseDeziiign ? 'center' : ''}
    align-items: center;
  
    ${p => (p?.overflowX && !p?.isDesigner) ? css`
        ${SlideNavigationWrapperItem} {
            &:last-child {
                padding-right: 60px;
            }
        }
    ` : null};
  
    ::-webkit-scrollbar {
        width: 10px; /* ширина scrollbar */
        height: 5px;
    }
    ::-webkit-scrollbar-track {
        background: #909090; /* цвет дорожки */
        visibility: hidden;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 310px; /* закругления плашки */
        background: #909090;
        visibility: visible;
    }

    ${({stretch, fullWidth}) => (stretch || fullWidth) && css`
        width: 100%;
        justify-content: flex-start;
        overflow-x: hidden;

        ${SlideNavigationWrapperItem} {

            margin-right: ${fullWidth ? 'inherit' : 'auto'};

            &:last-child {
                margin-right: 0px;
            }
        }
    `}
  
    ${({isDesigner, stretch}) => isDesigner && !stretch && css`
    //   padding-bottom: 8px;
    //   max-width: 858px;

    //   @media (max-width: ${LayoutConst.screen.l_12}px) {
    //     max-width: 700px;
    //   }

      ::-webkit-scrollbar {
        width: 0px; /* ширина scrollbar */
        height: 0px;
      }
    `}

    ${({isPayment, isPaymentSuccess}) => (isPayment) && css`
        max-width: ${isPaymentSuccess ? '368px' : '540px'};
        overflow: scroll;

       @media (max-width: ${LayoutConst.screen.mac13}px){
        max-width: 390px;
      }

       @media (max-width: ${LayoutConst.screen.l}px) {
            // max-width: 100vw;
           //max-width: none;
           max-width: ${isPaymentSuccess ? '478px' : 'none'};
           //max-width: calc((100vw - 32px) / 2 - 40px);
        }

       @media (max-width: ${LayoutConst.screen.s}px) {
           max-width: ${isPaymentSuccess ? '540px' : 'none'};
       }
    `}
`;

export const TitleGradient = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 25%;
    height: 100%;
    display: inline-block;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, ${({ theme }) => theme.tabs.gradient} 80%);
`;


export const WrapperSlider = styled.div<{showSliderGradient?:boolean, isPayment?: boolean}>`
    display: flex;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: 0px;
        right: -2px;
        width: 56px;
        height: 104px;
        display: inline-block;
        background: linear-gradient(90deg, rgba(231, 231, 231, 0) 0%, #e7e7e7 100%);
        top: ${({isPayment}) => isPayment ? 0 : 8}px;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        &::after {
            content: ${({isPayment}) => isPayment ? 'none' : ''};
        }
    }
`;
import styled, { css } from 'styled-components';
import { FInter, FlexBox, Colors } from '@brg/ui';
import { LayoutConst } from "../../../core";

export const SlideNavigationWrapper = styled(FlexBox)`
    flex-direction: column;
    width: 100%;
`;

export const DropdownItemsWrapper = styled.div<{isCompetition?: boolean, isWhite?: boolean, rightPos?: boolean, leftPos?: boolean}>`
    z-index: 100000;
    .dropdown-element-popup {
        z-index: 99999;
        background-color: ${Colors.geoWhite21};
        
  .dropdown-show {
    z-index: 99999;
  }
        .dropdown-list-item {
            width: 224px;
            background-color: ${p => p.theme.mainDropdownStyles.bg};
            color: ${p => p.theme.mainDropdownStyles.color};

            &:hover {
                background-color: ${p => p.theme.mainDropdownStyles.hoverBG};
            }
        }
    }
  
  ${({isCompetition}) => isCompetition && css`
    .dropdown-element-popup {
      background: #464645 !important;
      .dropdown-list-item {
        background: #464645 !important;
        color: #fefefe !important;

        &:hover {
          background: #2c2c2b !important;
        }
      }
    }
  `}

  ${({isWhite}) => isWhite && css`
    .dropdown-element-popup {
      background: transparent !important;
      .dropdown-list-item {
          font-size: 17px;
          line-height: 22px;
          letter-spacing: -0.02em;
          font-weight: 600 !important;
          color: ${p => p.theme.mainDropdownStyles.color} !important;

          background: ${p => p.theme.mainDropdownStyles.bg} !important;

          &:hover {
               background: rgb(231, 231, 231) !important;
          }
          
          @media(max-width: ${LayoutConst.screen.l_16}px) {
              font-size: 15px;
              line-height: 20px;
          }

          @media (max-width: ${LayoutConst.screen.md}px) {
              font-size: 13px;
                line-height: 15px;
                display: block;
                width: 403px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
          }
          @media (max-width: ${LayoutConst.screen.s - 1}px) {
              width: 170px;
          }
          
         
      }
        
    }
  `}
  .dropdown-element-popup {
    min-width: 224px !important;
    width: 224px;
    overflow: hidden;
         ${({rightPos, leftPos}) =>  leftPos ? css`
         @media (max-width: ${LayoutConst.screen.s - 1}px) {
           left: 50%;
           transform: translateX(-15%);
           min-width: 170px;
           max-width: 170px;
           overflow: hidden;

       }
        ` : rightPos ? css`
            @media (max-width: ${LayoutConst.screen.s - 1}px) {
            right: 0;
            min-width: 170px;
            max-width: 170px;
            overflow: hidden;

        }
         ` : css`
          @media (max-width: ${LayoutConst.screen.s - 1}px) {
            left: 50%;
            transform: translateX(-50%);
            min-width: 170px;
            max-width: 170px;
            overflow: hidden;

        }
         `
         }
    }
    .dropdown-button{
        ${({rightPos}) =>  rightPos && css`
            // margin-left: -10px;
        `}
    }
`;

export const SlideNavigationWrapperItem = styled(FInter.SmallTextBoldFlex)<{
    active: boolean;
    white_theme: boolean;
    padding?: number;
    whiteSpace?: boolean;
    disableTab?: boolean;
    isTitle?: boolean;
    isDesigner?: boolean;
    isHseDeziiign?: boolean;
    smallTab?: boolean;
    isCGRAVE?: boolean;
    offsetVisible?: boolean;
    floatingTabs?: boolean;
    blueSelect?: boolean;
    color?: string;
    hover?: string;
    isTeamOrCoursePage?: boolean
    isGreyColorText?: boolean,
    noLeftPadding?: boolean,
    customGap?: string | number
    isExport?: boolean
    $competitionMobileUnderline?: boolean
    $showActiveTabUnderline?: boolean
    $forceMobile?: boolean
    activeUnderlineColor?: string
}>`
    color: ${(p) => {
      if(!p.active && p.isGreyColorText) {
        return p.theme.designerPage.slideHover
      }
      return (p.active ? (p?.color || p.theme.designerPage.fill) : p.theme.designerPage.slideLineInActive)
    }};
    cursor: pointer;
    transition: all 0.2s;
    //padding-bottom: 10px;
    // border-bottom: 2px solid ${({active, theme}) => (active ? theme.designerPage.slideLine : 'transparent')};
    @media (min-width: ${LayoutConst.screen.s}px) {
        ${(p) =>
          p.$showActiveTabUnderline == null &&
          !p.blueSelect &&
          !p.isTitle &&
          !(p.isDesigner && !p.smallTab && !p.isExport) &&
          css`
            border-bottom: 2px solid
              ${p.active
                ? p.activeUnderlineColor ??
                  p.theme.designerPage.slideNavActiveTabUnderline ??
                  p.theme.designerPage.slideLine
                : 'transparent'};
          `}
    }
    font-weight: 600;
    font-size: ${({isDesigner}) => isDesigner ? 15 : 17}px;
    white-space: nowrap;
    line-height: ${({isDesigner}) => isDesigner ? 20 : 22}px;
    position: relative;
    letter-spacing: -0.02em;
    align-items: center;
    z-index: 2;
    text-transform: ${({isDesigner}) => isDesigner ? 'lowercase' : ''};
    display: block;
        max-width: ${({isTitle}) => isTitle ? 'none' : '460px'};
        overflow: ${({isTitle}) => isTitle ? 'visible' : 'hidden'};
        white-space: ${({isTitle}) => isTitle ? 'normal' : 'nowrap'};
        text-overflow: ${({isTitle}) => isTitle ? 'unset' : 'ellipsis'};

    .corner-svg {
        width: 10px;
        height: 10px;
        margin-left: 5px;
        position: absolute;
        right: -15px;
        top: 50%;
        transform: translateY(-50%);
        transition: fill 0.2s;
    }

    ${({ blueSelect , active, theme }) => blueSelect && css`
        background-color: ${ active ? theme.designerPage.blueSelectBG : 'transparent' };
        color: ${ active ? theme.designerPage.blueSelectColor : theme.designerPage.slideLineInActive };
        padding: ${ active ? '6px 16px' : '6px 0px' };
        border-radius: 3px;
        // height: 34px;
    `}; 
    
    ${p => p.isTitle ? css`
        font-weight: 600;
        font-size: 60px;
        line-height: 70px;
    `: null}

    ${p => p.disableTab ? css`
        color: ${Colors.galBlack31};
        pointer-events: none;
    `: null}
    
    &:not(:last-child) {
        margin-right: ${({customGap, $forceMobile}) => customGap || customGap === 0? customGap : $forceMobile ? 0 : 24}px;
    }

    ${p => p.isDesigner && !p?.smallTab && !p?.isExport ? css`
      padding: 8px 16px;

      @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 6px 16px;
      }

      border-radius: 3px;
      user-select: none;
      
      ${p.active ? css`
      background: ${p.isCGRAVE ? '#2C2C2B' : p.theme.designerPage.slideItemBg};
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
      color: ${p.isCGRAVE ? '#FEFEFE' : ''};


      &:first-child {
        padding-left: 16px;
      }
    `: null}

    
    `: null}
    
    ${({ active, hover }) => css`
        &:hover {
            color: ${p => active ? hover : p.theme.designerPage.slideHover };
            transition: color 0.2s;

            .corner-svg {
                path {
                    fill: ${p => p.theme.designerPage.slideHover };
                    transition: fill 0.2s;
                }
            }
        }
        `
    };

    ${p => p.smallTab ? css`
        border-radius: 3px;
        user-select: none;
        background: transparent !important;
        box-shadow: none !important;
        ${p.isDesigner && 'padding: 8px 16px;'}
    ` : null};

    
    ${p => !p.isTitle ? css`
     @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
    ` : null};


    @media (max-width: ${LayoutConst.screen.m}px) {
        padding-bottom: ${({ blueSelect, isHseDeziiign, isTeamOrCoursePage, isDesigner }) => (blueSelect || isDesigner) ? '6px' : 0};
        margin-bottom: ${({ blueSelect, isHseDeziiign, isTeamOrCoursePage, isDesigner }) => '0px'};
        font-weight: 600;
        
        ${({ floatingTabs, isDesigner }) => floatingTabs ? css`
            transition: none;
        ` : isDesigner ? css`
            font-size: 15px;
            line-height: 20px;
            padding: 6px 16px;
        ` : null};

        &:not(:last-child) {
            margin-right: ${p => p?.padding ? `${p?.padding}px` : '16px'};
        }
    }
    @media (max-width: ${LayoutConst.screen.m}px) {
        display: block;
        max-width: ${({isTitle}) => isTitle ? 'none' : '270px'};
        overflow: ${({isTitle}) => isTitle ? 'visible' : 'hidden'};
        white-space: ${({isTitle}) => isTitle ? 'normal' : 'nowrap'};
        text-overflow: ${({isTitle}) => isTitle ? 'unset' : 'ellipsis'};
    }

    @media(max-width: 320px) {
        white-space: ${p => p?.whiteSpace ? 'pre-wrap' : 'nowrap'};
    }

    @media(max-width: 320px) {
        white-space: ${p => p?.whiteSpace ? 'pre-wrap' : 'nowrap'};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        background: none;
        border-top: none;
        border-left: none;
        border-right: none;
        box-shadow: none;
    }

    ${p => p.isTitle ? css`
        @media (max-width: ${LayoutConst.screen.l_12}px) {
            font-size: 65px;
            line-height: 75px;
            letter-spacing: -0.005em;
        }

        @media (max-width: ${LayoutConst.screen.m_1024}px) {
            font-size: 43px;
            line-height: 51px;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px;
            line-height: 34px;
            letter-spacing: -0.56px;
        }
        
        @media (max-width: ${LayoutConst.screen.sm}px) {
            font-size: 28px;
            line-height: 34px;
        }
    `: null}

    @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 6px 16px;
        margin-right: 0 !important;

        ${p => p.noLeftPadding && !p.$forceMobile && `padding-left: 0;`}

        :hover {
            color: ${(p) => (p.active ? (p?.color || p.theme.designerPage.fill) : p.theme.designerPage.slideLineInActive)};
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding-left: 16px;
        border-radius: 0;
        ${(p) =>
          p.$showActiveTabUnderline === false
            ? css`
                border-bottom: 2px solid transparent;
              `
            : p.$competitionMobileUnderline
            ? css`
                border-bottom: ${p.active ? '2px solid #FFFFFF' : '2px solid transparent'};
                margin-bottom: -1px;
              `
            : css`
                border-bottom: ${p.active
                  ? `2px solid ${
                      p.activeUnderlineColor ??
                      p.theme.designerPage.slideNavActiveTabUnderline ??
                      p.theme.designerPage.slideLine
                    }`
                  : '2px solid transparent'};
              `}
    }

    ${(p) =>
      p.$forceMobile &&
      css`
        padding: 6px 16px;
        border-radius: 0;
        ${p.$showActiveTabUnderline === false
          ? css`
              border-bottom: 2px solid transparent;
            `
          : p.$competitionMobileUnderline
          ? css`
              border-bottom: ${p.active
                ? '2px solid #FFFFFF'
                : '2px solid transparent'};
              margin-bottom: -1px;
            `
          : css`
              border-bottom: ${p.active
                ? `2px solid ${
                    p.activeUnderlineColor ??
                    p.theme.designerPage.slideNavActiveTabUnderline ??
                    p.theme.designerPage.slideLine
                  }`
                : '2px solid transparent'};
            `}
      `}

    ${(p) =>
      p.$competitionMobileUnderline &&
      css`
        max-width: none;
        overflow: visible;
        text-overflow: unset;

        @media (max-width: ${LayoutConst.screen.m}px) {
          max-width: none;
          overflow: visible;
          text-overflow: unset;
        }
      `}
`;

export const SlideNavigationWrapperLine = styled.div`
    background: ${(p) => p.theme.designerPage.slideLine};
    opacity: 0.21;
    border: 1px solid ${(p) => p.theme.designerPage.slideLine};
    box-sizing: border-box;
    width: 100%;
    height: 1px;
`;

export const SlideNavigationItemsShadow = styled(FlexBox)`
    background: ${(p) => p.theme.designerPage.slideShadow};
    height: 100%;
    width: 64px;
    position: absolute;
    right: 0;
`

export const SlideNavigationItemsWrapper = styled(FlexBox)<{ overflowX?: boolean, isPaymentSuccess?: boolean, isDesigner?: boolean, isPayment?: boolean, stretch?: boolean, fullWidth?: boolean, smallTab?: boolean, gradientVisible?: boolean, isHseDeziiign?: boolean, $competitionMobileBaseline?: boolean }>`
    position: relative;

    ${(p) =>
      p.$competitionMobileBaseline &&
      css`
        @media (max-width: ${LayoutConst.screen.s - 1}px) {
          margin-left: -10px;
          /* border-bottom: 1px solid #5d5d5d; */
        }
      `}
    //margin-bottom: 16px;
    // align-items: {({isHseDeziiign}) => isHseDeziiign ? 'center' : ''}
    align-items: center;
  
    ${p => (p?.overflowX && !p?.isDesigner) ? css`
        ${SlideNavigationWrapperItem} {
            &:last-child {
                padding-right: 60px;
            }
        }
    ` : null};
  
    ::-webkit-scrollbar {
        width: 10px; /* ширина scrollbar */
        height: 5px;
    }
    ::-webkit-scrollbar-track {
        background: #909090; /* цвет дорожки */
        visibility: hidden;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 310px; /* закругления плашки */
        background: #909090;
        visibility: visible;
    }

    ${({stretch, fullWidth}) => (stretch || fullWidth) && css`
        width: 100%;
        justify-content: flex-start;
        overflow-x: hidden;

        ${SlideNavigationWrapperItem} {

            margin-right: ${fullWidth ? 'inherit' : 'auto'};

            &:last-child {
                margin-right: 0px;
            }
        }
    `}
  
    ${({isDesigner, stretch}) => isDesigner && !stretch && css`
    //   padding-bottom: 8px;
    //   max-width: 858px;

    //   @media (max-width: ${LayoutConst.screen.l_12}px) {
    //     max-width: 700px;
    //   }

      ::-webkit-scrollbar {
        width: 0px; /* ширина scrollbar */
        height: 0px;
      }
    `}

    ${({isPayment, isPaymentSuccess}) => (isPayment) && css`
        max-width: ${isPaymentSuccess ? '368px' : '540px'};
        overflow: scroll;

       @media (max-width: ${LayoutConst.screen.mac13}px){
        max-width: 390px;
      }

       @media (max-width: ${LayoutConst.screen.l}px) {
            // max-width: 100vw;
           //max-width: none;
           max-width: ${isPaymentSuccess ? '478px' : 'none'};
           //max-width: calc((100vw - 32px) / 2 - 40px);
        }

       @media (max-width: ${LayoutConst.screen.s}px) {
           max-width: ${isPaymentSuccess ? '540px' : 'none'};
       }
    `}
`;

export const TitleGradient = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 25%;
    height: 100%;
    display: inline-block;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, ${({ theme }) => theme.tabs.gradient} 80%);
`;


export const WrapperSlider = styled.div<{showSliderGradient?:boolean, isPayment?: boolean}>`
    display: flex;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: 0px;
        right: -2px;
        width: 56px;
        height: 104px;
        display: inline-block;
        background: linear-gradient(90deg, rgba(231, 231, 231, 0) 0%, #e7e7e7 100%);
        top: ${({isPayment}) => isPayment ? 0 : 8}px;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        &::after {
            content: ${({isPayment}) => isPayment ? 'none' : ''};
        }
    }
`;
